class PrepaintedFunctionality extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            fakeVariantButtonPrepainted: '.radio-custom',
            trueVariantButtonPrepainted: '.variant-input input[value="Physical prepainted"]',

            simplePhysicalProduct: '.variant-input input[value="Physical"]',
            simplePhysicalProductWrapper: '.variant-input[data-value="Physical"]',
        }

        this.elements = {
            fakeVariantButtonPrepainted: this.querySelector(this.selectors.fakeVariantButtonPrepainted),
            trueVariantButtonPrepainted: document.querySelector(this.selectors.trueVariantButtonPrepainted),
            simplePhysicalProduct: document.querySelector(this.selectors.simplePhysicalProduct),
            simplePhysicalProductWrapper: document.querySelector(this.selectors.simplePhysicalProductWrapper),

        }

        this.classes = {
            checked: 'checked',
            disabled: 'disabled',
            visuallyChecked: 'visually-checked'
        }

        this.init();
        console.log(this.elements.simplePhysicalProductWrapper);
    }

    init() {
        this.elements.fakeVariantButtonPrepainted.addEventListener("click", (event) => {
            event.preventDefault();
            if (!this.elements.fakeVariantButtonPrepainted.classList.contains(this.classes.disabled)) {

                if (this.elements.fakeVariantButtonPrepainted.classList.contains(this.classes.checked)) {

                    this.removePrepainted();
                    this.selectSimplePhysicalProduct();
                } else {
                    this.addPrepainted();
                }

            }
        });

        document.addEventListener('variant:change', (detail) => {
            if (detail.detail.value.includes('Digital')) {
                this.removePrepainted();
            } else if (detail.detail.value.includes('Physical')) {
                if (this.elements.fakeVariantButtonPrepainted.classList.contains(this.classes.checked)) {
                    this.addPrepainted();
                }
            }
        });
    }

    removePrepainted() {
        this.elements.fakeVariantButtonPrepainted.classList.remove(this.classes.checked);
        this.elements.trueVariantButtonPrepainted.checked = false;
        this.elements.simplePhysicalProductWrapper.classList.remove(this.classes.visuallyChecked);
        this.elements.simplePhysicalProductWrapper.classList.remove(this.classes.checked);
    }

    selectSimplePhysicalProduct() {
        this.elements.simplePhysicalProduct.click();
        this.elements.simplePhysicalProduct.checked = true;
    }

    addPrepainted() {
        this.elements.fakeVariantButtonPrepainted.classList.add(this.classes.checked);
        this.elements.trueVariantButtonPrepainted.click();
        this.elements.trueVariantButtonPrepainted.checked = true;
        this.elements.simplePhysicalProductWrapper.classList.add(this.classes.visuallyChecked);
        this.elements.simplePhysicalProductWrapper.classList.add(this.classes.checked);
    }
}

customElements.define('prepainted-functionality', PrepaintedFunctionality);
